<template>
  <div class="gz-box" v-if="show" @click="handleMaskClick">
  	<div class="gz-modal" @click.stop="handleModalClick">
  		<div class="gz-tabs">
  			<div class="gz-tab" :class="{ 'gz-tab--active': currentTab === 0 }" @click="switchTab(0)">
  				<div class="gz-tab-item">
  					<span class="gz-tab-label">{{$t('all.guanzhong')}}</span>
  					<span class="gz-tab-num">{{followTotal}}</span>
  				</div>
  				<div class="gz-tab-line" v-if="currentTab === 0"></div>
  			</div>
  			<div class="gz-tab" :class="{ 'gz-tab--active': currentTab === 1 }" @click="switchTab(1)">
  				<div class="gz-tab-item">
  					<span class="gz-tab-label">{{$t('all.fensi')}}</span>
  					<span class="gz-tab-num">{{fansTotal}}</span>
  				</div>
  				<div class="gz-tab-line" v-if="currentTab === 1"></div>
  			</div>
  			<img class="gz-close" src="../../assets/image/tanchuang_x_b@2x.png" alt="" @click.stop="handleClose" />
  		</div>
  		<div class="gz-list" ref="listContainer" @scroll="handleScroll">
  			<div class="gz-item" v-for="(item,index) in list" :key="index" @click.stop="handleGoUser(item)">
  				<img class="gz-item-avatar" :src="item.headPortrait" alt="" />
  				<div class="gz-item-info">
  					<span class="gz-item-nick">{{item.nickName}}</span>
  					<span class="gz-item-uid">ID {{item.recodeCode || item.userId}}</span>
  				</div>
  				<!-- 关注中：互关/已关注，点击取消关注 -->
  				<div class="gz-btn" v-if="currentTab === 0"
  					:class="item.followHe == 1 ? 'gz-btn--mutual' : 'gz-btn--followed'"
  					@click.stop="toggleFollow(item,index)">
  					{{item.followHe == 1 ? $t('all.huguan') : $t('all.yiguanzhu')}}
  				</div>
  				<!-- 粉丝：互关/关注，点击关注或取关 -->
  				<div class="gz-btn" v-else
  					:class="item.followHe == 1 ? 'gz-btn--mutual' : 'gz-btn--follow'"
  					@click.stop="toggleFollow(item,index)">
  					{{item.followHe == 1 ? $t('all.huguan') : $t('all.guanzhu')}}
  				</div>
  				<div class="gz-more-wrap">
  					<img class="gz-more" src="../../assets/image/dian_22_1@2x.png" alt="" @click.stop="toggleMenu(index)" />
  					<div class="gz-menu" v-if="menuIndex === index" @click.stop="handleDelete(item,index)">
  						{{currentTab === 0 ? $t('all.shanchuguanzhu') : $t('all.yichufensi')}}
  					</div>
  				</div>
  			</div>
  			<kong v-if="loaded && list.length === 0" />
  		</div>
  	</div>
  </div>
</template>

<script>
import { getUserFollowList, getUserVermicelliList, followOrCancelFollow, deleteVermicelli } from "@/api/user";
import kong from "../kong/kong.vue";
export default {
  components: {
	kong
  },
  data() {
    return {
	  show: false,
	  currentTab: 0, // 0=关注中 1=粉丝
	  list: [],
	  page: 1,
	  pageSize: 10,
	  hasMore: true,
	  isLoading: false,
	  loaded: false,
	  followTotal: 0,
	  fansTotal: 0,
	  menuIndex: -1,
	  followLoadingMap: {}
    };
  },
  methods: {
	//显示弹框 tab: 0=关注中 1=粉丝
	showGuanzhu(tab) {
		this.currentTab = tab === 1 ? 1 : 0;
		this.show = true;
		this.followTotal = 0;
		this.fansTotal = 0;
		this.loadCounts();
		this.loadFirstPage();
	},
	//关闭弹框
	handleClose() {
		this.show = false;
		this.menuIndex = -1;
	},
	handleMaskClick() {
		if (this.menuIndex >= 0) {
			this.menuIndex = -1;
			return;
		}
		this.handleClose();
	},
	handleModalClick() {
		if (this.menuIndex >= 0) {
			this.menuIndex = -1;
		}
	},
	switchTab(idx) {
		if (idx === this.currentTab) return;
		this.currentTab = idx;
		this.menuIndex = -1;
		this.loadFirstPage();
	},
	loadFirstPage() {
		this.list = [];
		this.page = 1;
		this.hasMore = true;
		this.loaded = false;
		this.getList();
	},
	async loadCounts() {
		try {
			const params = { page: 1, size: 1 };
			const [fRes, fanRes] = await Promise.all([
				getUserFollowList(params),
				getUserVermicelliList(params)
			]);
			if (fRes && fRes.total != null) this.followTotal = fRes.total;
			if (fanRes && fanRes.total != null) this.fansTotal = fanRes.total;
		} catch (e) {
			console.error('获取关注/粉丝数量失败:', e);
		}
	},
	async getList() {
		if (this.isLoading || !this.hasMore) return;
		this.isLoading = true;
		try {
			const params = { page: this.page, size: this.pageSize };
			let res;
			if (this.currentTab === 0) {
				res = await getUserFollowList(params);
			} else {
				res = await getUserVermicelliList(params);
			}
			const rows = res.rows || (Array.isArray(res.data) ? res.data : []);
			if (res.total != null) {
				if (this.currentTab === 0) {
					this.followTotal = res.total;
				} else {
					this.fansTotal = res.total;
				}
			}
			const normalized = rows.map((r) => ({
				...r,
				headPortrait: r.headPortrait || r.avatar || '',
				nickName: r.nickName || r.userNickName || r.nickname || '',
				recodeCode: r.recodeCode || r.memberId || r.code || '',
				userId: r.userId || r.uid || r.id || ''
			}));
			if (this.page === 1) {
				this.list = normalized;
			} else {
				this.list = [...this.list, ...normalized];
			}
			if (normalized.length < this.pageSize) {
				this.hasMore = false;
			} else {
				this.page++;
			}
		} catch (e) {
			console.error('列表加载失败:', e);
		} finally {
			this.isLoading = false;
			this.loaded = true;
		}
	},
	//滚动加载更多
	handleScroll() {
		if (this.isLoading || !this.hasMore) return;
		const container = this.$refs.listContainer;
		const isAtBottom = container.scrollTop + container.clientHeight >= container.scrollHeight - 50;
		if (isAtBottom) {
			this.getList();
		}
	},
	//关注/取关
	async toggleFollow(item, index) {
		const uid = item.userId || item.id;
		if (!uid || this.followLoadingMap[uid]) return;
		this.followLoadingMap[uid] = true;
		try {
			await followOrCancelFollow({ viewUserId: uid });
			if (this.currentTab === 0) {
				//关注列表：取关成功后从列表移除
				this.list.splice(index, 1);
				this.followTotal = Math.max(this.followTotal - 1, 0);
			} else {
				//粉丝列表：切换回关状态，条目保留
				const prev = item.followHe == 1;
				this.$set(this.list, index, { ...item, followHe: prev ? 0 : 1 });
				if (prev) {
					this.followTotal = Math.max(this.followTotal - 1, 0);
				} else {
					this.followTotal = this.followTotal + 1;
				}
			}
			this.$emit('change');
		} catch (e) {
			console.error('关注操作失败:', e);
		} finally {
			this.followLoadingMap[uid] = false;
		}
	},
	toggleMenu(index) {
		this.menuIndex = this.menuIndex === index ? -1 : index;
	},
	//删除关注/移除粉丝
	async handleDelete(item, index) {
		this.menuIndex = -1;
		const uid = item.userId || item.id;
		if (!uid || this.followLoadingMap[uid]) return;
		this.followLoadingMap[uid] = true;
		try {
			if (this.currentTab === 1) {
				//移除粉丝
				await deleteVermicelli({ viewUserId: uid });
				this.list.splice(index, 1);
				this.fansTotal = Math.max(this.fansTotal - 1, 0);
			} else {
				//取消关注
				await followOrCancelFollow({ viewUserId: uid });
				this.list.splice(index, 1);
				this.followTotal = Math.max(this.followTotal - 1, 0);
			}
			this.$emit('change');
		} catch (e) {
			console.error('删除操作失败:', e);
		} finally {
			this.followLoadingMap[uid] = false;
		}
	},
	//跳转用户主页
	handleGoUser(item) {
		const uid = item.userId || item.id;
		if (!uid) return;
		this.handleClose();
		this.$router.push({ path: '/yonghuzhuye', query: { userId: uid } });
	}
  }
};
</script>
<style scoped lang="scss">
	@import "./guanzhu.css";
</style>



// WEBPACK FOOTER //
// guanzhu.vue?3d89b7e4